import $ from '@nuskin/nuskinjquery';

const AdrEditService = function() {
    "use strict";

    let ADR_EDIT_STORAGE_KEY = 'adrEdit';

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    let publicMethods = {
        isEcom3Mode : function() {
            let isEcom3 = true;
            if(getStoredAdr() !== 'null') {
                isEcom3 = false;
            }
            return isEcom3;
        },
        getAdrEdit : function() {
            return getStoredAdr();
        },
        setAdrEdit : function(adrOrderNumber) {
            if (adrOrderNumber != null) {
                writeAdrToStorage(adrOrderNumber);
                try {
                    $("#cart-ecom3").attr("id", "cart");
                    $("#yourCartLink-ecom3").attr("id", "yourCartLink");
                    $("#ribbon-cart-pv-ecom3").attr("id", "ribbon-cart-pv");
                    $("#cart-shopApp").hide();
                    $("#adrEditModeNumber").text(AdrEditService.getAdrEdit());
                    $("#adrEditModeCart").show();
                    $("#yourCartLink").attr("href",$("#yourCartLink").attr("href").replace("/shop.html", "/shop.adr-edit.html"));
                    $("#yourCartLink").attr("href",$("#yourCartLink").attr("href").replace("/cart.html", "/shop.adr-edit.html"));
                } catch(e) {
                    console.error(e);
                }
            }
        },
        clearAdrEdit : function() {
            writeAdrToStorage(null);
            try {
                $("#cart-shopApp").attr("id", "cart");
                $("#yourCartLink-shopApp").attr("id", "yourCartLink");
                $("#ribbon-cart-pv-shopApp").attr("id", "ribbon-cart-pv");
                $("#cart-ecom3").hide();
                if ($("#yourCartLink").length){
                    $("#yourCartLink").attr("href", $("#yourCartLink").attr('href').replace("shop.adr-edit.html","cart.html"));
                }
                if ($("#mobileCartLink").length){
                    $("#mobileCartLink").attr("href", $("#yourCartLink").attr('href').replace("shop.adr-edit.html","cart.html"));
                }
                $("#adrEditModeCart").hide();
            } catch(e) {
                console.error(e);
            }

        }
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getStoredAdr() {
        let adrOrderNumber = 'null';
        if (sessionStorage.getItem(ADR_EDIT_STORAGE_KEY) !== null){
            adrOrderNumber = sessionStorage.getItem(ADR_EDIT_STORAGE_KEY);
        }
        return adrOrderNumber;
    }

    function writeAdrToStorage(adrOrderNumber) {
        if (adrOrderNumber !== null){
            sessionStorage.setItem(ADR_EDIT_STORAGE_KEY, adrOrderNumber);
        }
        else {
            sessionStorage.setItem(ADR_EDIT_STORAGE_KEY, null);
        }
    }

    return publicMethods;
}();

export default AdrEditService;
